module.exports = __webpack_public_path__ + "img/inquire.9a44e940.png";